// extracted by mini-css-extract-plugin
export default {"header":"Jw","fullPage":"Kw","closed":"Lw","minimize":"Mw","redcircle":"Nw","container":"Ow","text":"Pw","centered":"Qw","escapex":"Rw"};
    if(module.hot) {
      // 1715632474998
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  